import { render } from "./ClinicCsvOffcanvas.vue?vue&type=template&id=35a92f10&scoped=true"
import script from "./ClinicCsvOffcanvas.vue?vue&type=script&lang=js"
export * from "./ClinicCsvOffcanvas.vue?vue&type=script&lang=js"

import "./ClinicCsvOffcanvas.vue?vue&type=style&index=0&id=35a92f10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a92f10"]])

export default __exports__